import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioUtilService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getMontoEnLetras(codigoBaseDatos: string, monto: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'util/pesosLetras',
        [ codigoBaseDatos, { monto } ]
      );
      return response;
    } catch (e) {
      console.log(`ServicioUtilService.getMontoEnLetras() ${e}`);
    }
    return null;
  }
}
